import {parseISO, addHours, isAfter} from "date-fns";

import ServiceResponse from "../models/ServiceResponse";


export default class OrgRuleManager
{
    constructor(orgConfig, ruleType)
    {
        this.ruleType = ruleType;
        this.hasRule = (orgConfig?.Rules[ruleType]);
        this.allowed =  orgConfig?.Rules[ruleType]?.allowed;
        this.hasExpiration = orgConfig?.Rules[ruleType]?.expiration?.expires;
        this.expireAfterXHours = orgConfig?.Rules[ruleType]?.expiration?.expiresAfterHours ?? 48;

        this.validate = this.validate.bind(this);
    }

    validate(inspectionDate ,notAllowedMsg, expiredMsg)
    {
        if ((!this.hasRule) || (!this.allowed))
        {
            return new ServiceResponse(true, (notAllowedMsg) ? notAllowedMsg : "Your organization does not allow " + this.ruleType + ".");
        }
        if (this.hasExpiration)
        {
            // we may be in a different time zone. Convert to UTC to do the comparison
            var observationDateTime = parseISO(inspectionDate);
            var boundaryDateTime = addHours(observationDateTime, this.expireAfterXHours);
            if (isAfter(new Date(), boundaryDateTime))
            {
                return new ServiceResponse(true, (expiredMsg) ? expiredMsg :  "Your organization does not allow " + this.ruleType + " more than " + this.expireAfterXHours + " hours after it was created.");
            }
        }
        return new ServiceResponse(false, "");
    }


}